module.exports = __webpack_public_path__ + "img/4a994a1.jpg";